import React from 'react';
import PropTypes from 'prop-types';
import { CardContent } from '@material-ui/core';
import { Icon, Typography } from '@knockrentals/knock-shared-web-v2';
import { ActionTile } from '../../../../../ActionTile';
import BrandingTile from './BrandingTile';
import { makeCss } from '../../../../../../../../knock-design-system';
import { BRANDING_TILES } from './constants';

const { PHOTOS } = BRANDING_TILES;

const useCss = makeCss({
  imageCount: {
    alignItems: 'center',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'space-between',
    paddingTop: '24px',
  },
});

const Photos = ({ openImageDialog, photosCount }) => {
  const css = useCss();

  return (
    <BrandingTile title={PHOTOS.TITLE}>
      <ActionTile
        actionOnClick={openImageDialog}
        actionText={PHOTOS.ACTION_TEXT}
        iconName="camera"
        subText={PHOTOS.SUBTEXT}
      >
        {photosCount > 0 && (
          <CardContent css={css.imageCount}>
            <Icon name="picture-stack" size={32} color="primary.600" />

            <Typography variant="caption" color="text.tertiary">
              {`${photosCount} photo${photosCount !== 1 ? 's' : ''}`}
            </Typography>
          </CardContent>
        )}
      </ActionTile>
    </BrandingTile>
  );
};

Photos.propTypes = {
  openImageDialog: PropTypes.func,
  photosCount: PropTypes.number,
};

export default Photos;
